import { useContext, useEffect } from 'react';
import { IS_SERVER_RENDER } from '@namespace/helpers';
import { socketSend } from '@namespace/socket';
import { UserContext } from '@namespace/user';

if (!IS_SERVER_RENDER) {
  window.FE = {};
  window.FE.socket_send = socketSend;
}

const useAddFEToWindow = () => {
  const [user] = useContext(UserContext);

  useEffect(() => {
    if (user) {
      window.FE.user = user;
    }
  }, [user]);
};

export default useAddFEToWindow;
